import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Client, User } from "resourceModels";
import { getResource } from "selectors/resources";

import "./style.scss";

const BLOCK_NAME = "UserImage";

class UserImage extends React.Component {
  renderImage() {
    const {
      /** @type Client */
      client,
      /** @type User */
      user
    } = this.props;

    if (user.profilePicture) {
      return (
        <div
          className={`${BLOCK_NAME}__image ${BLOCK_NAME}__image--has-picture`}
          style={{
            backgroundImage: `url(${user.profilePicture})`
          }}
        >
          {this.props.children}
        </div>
      );
    }

    if (this.props.showDefaultPicture) {
      return (
        <div
          className="UserImage__image UserImage__image--default-picture"
          style={{
            backgroundImage: "url(https://static.ada.support/DefaultAvatar.svg)"
          }}
        >
          {this.props.children}
        </div>
      );
    }

    return (
      <div
        className="UserImage__image UserImage__image--initials"
        style={{
          backgroundColor: client.tint
        }}
      >
        {user.name[0]}
      </div>
    );
  }

  render() {
    return (
      // Not going to have a keyboard handler
      <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, max-len
        role="button"
        className={`
                    UserImage
                    ${this.props.customClassName ? this.props.customClassName : ""}
                `}
        style={{
          height: this.props.height,
          width: this.props.width,
          fontSize: this.props.height
        }}
        onClick={() => this.props.onClick && this.props.onClick()}
      >
        {this.renderImage()}
      </div>
    );
  }
}

UserImage.propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
  client: PropTypes.instanceOf(Client).isRequired
};

function mapState(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = connect(mapState)(UserImage);

Connector.propTypes = {
  user: PropTypes.instanceOf(User).isRequired
};

export default Connector;
